import React, { PureComponent } from 'react';
import styled from 'styled-components';

import mediaWidth from '../../../utils/mediaWidth/mediaWidth';

export default class Paragraph extends PureComponent {
    render() {
        const {
            className,
            img,
            text,
            handleOpen,
            uuid,
        } = this.props;
        return (
            <Root className={className}>
                <Image src={img} onClick={() => handleOpen([img], uuid)} />
                <Text>{text}</Text>
            </Root>
        );
    }
}

const Text = styled.div`
    margin-top: 16px;

    font-size: 16px;
    line-height: 24px;
`;

const Image = styled.img`
    width: 100%;
    height: 241px;
    cursor: pointer;

    ${mediaWidth.m} {
        height: 234px;
    };

    ${mediaWidth.l} {
        height: 207px;
    };

    ${mediaWidth.xl} {
        height: 297px;
    };
`;

const Root = styled.div`
    display: flex;
    flex-direction: column;

    :not(:first-child) {
        margin-top: 32px;
    };

    /* :nth-child(n + 4) {
        margin-top: 32px;
    }; */
`;
